import { IPagedCollection, WccDto, DownloadFileDto, FileWccInfoDto } from '@sr/dto';
import { wccApi } from 'entities/wcc/api';
import { WCC_BASE_URL } from 'shared/api/api';
import { CollectionParams } from 'shared/api/rtk-query';
import { pagingDataToParams } from 'utils/remote-paged-collection.hook';


const injectedApi = wccApi.injectEndpoints({
  endpoints: (builder) => ({
    getWccExportList: builder.query<IPagedCollection<WccDto>, CollectionParams>({
      query: ({ paging, filter }: CollectionParams) => ({
        url: `${WCC_BASE_URL}/export/list?${filter}`,
        params: paging && pagingDataToParams(paging),
        method: 'GET'
      })
    }),
    runExport: builder.mutation<DownloadFileDto[], number[]>({
      query: (idList: number[]) => ({
        url: `${WCC_BASE_URL}/export`,
        method: 'POST',
        body: idList
      })
    }),
    getFilesWccList: builder.query<IPagedCollection<FileWccInfoDto>, CollectionParams>({
      query: ({ paging, filter }: CollectionParams) => ({
        url: `${WCC_BASE_URL}/wcc-files-export?${filter}`,
        params: paging && pagingDataToParams(paging),
        method: 'GET'
      })
    }) 
  }),
  overrideExisting: true
});

export const wccExportApi = injectedApi.enhanceEndpoints({
  addTagTypes: ['*'],
  endpoints: {
    getWccExportList: {
      providesTags: ['*']
    }
  }
});
